import { Button, Form, Modal, Row, Select, Space, Typography } from 'antd'
import { InputFields } from 'components/common'
import React, { useEffect, useState } from 'react'
import { FIELD_TYPE } from 'types/enums';
import { DataFormField } from 'types/models/input-field-type';
import Notification from "components/common/notification/notification";
import residentialNurseService from "api/residentialNurse";
import ModalPrintPPT from '../ModalPrintPPT/ModalPrintPPT';

const {INPUT, SELECT, DATE} = FIELD_TYPE;

const ModalOptionPrint = ({isShowModal, handleOk, handleCancel, listId, dataPPTOption}) => {
  const [formData] = Form.useForm();
  const [label, setLabel] = useState(null);
  const [option, setOption] = useState([]);
  const [isShowModalPrintPPT, setIsShowModalPrintPPT] = useState(false);

  const onFinish = async value => {
    handleCancel();
  };

  const handleOnChange = (e) => {
    const itemSelect = option.find(item => item.value === e);
    setLabel(itemSelect.label);
  }

  const inputItems: DataFormField[] = [
    {
      type: SELECT,
      label: "Chọn vật tư",
      name: "tenVatTu",
      css: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
      labelCol: {xs: 24, sm: 24, md: 8, lg: 8, xl: 8},
      wrapperCol: {xs: 24, sm: 24, md: 16, lg: 16, xl: 16},
      // onChange: onChangeValue
    },
  ];
  const [field, setField] = useState(inputItems);

  useEffect(()=>{
    getListLoaiTTT();
  },[])


  const getListLoaiTTT = async () => {
    try {
      const res = await residentialNurseService.getListLoaiTTT();
      const options = res.data.map((item) => {
        return { value: item.id, label: item.tenTheoThuongMai } || [];
      });
      // inputItems.find((e) => e.name === "tenVatTu").options = options;
      setOption(options)
    } catch (error) {
      Notification(
        "error",
        "Đã xảy ra lỗi khi lấy danh sách loại thủy tinh thể nhân tạo"
      );
    }
  };


  const handleOnSubmit = async () => {
    const value = formData.getFieldValue("tenVatTu");
    dataPPTOption = dataPPTOption.map(item => ({
      ...item,
      noiDung: value.label
    }))
    setIsShowModalPrintPPT(true);
    // const value = await formData.getFieldValue("lyDoHoan");
    // const newData = {
    //   list_id: listID,
    //   lydohoan: value,
    //   nguoiDuyetHoan: localStorage.getItem('fullName'),
    //   thoiGianHoan: moment().format(FORMAT_TIME.dateTime)
    // }
    // await submitRefunds(newData); 
  }

  const handleOpenPPT = () => {
    setIsShowModalPrintPPT(false);
  };

  const handleCancelPrintPPT = () => {
    setIsShowModalPrintPPT(false);
  };

  return (
    <Modal
      title="Nội dung phụ thu"
      centered
      open={isShowModal}
      onCancel={handleCancel}
      width={"80%"}
      className="modal-tab-pay"
      footer=""
    >
      <div className="table-results">
        <Form form={formData} onFinish={onFinish}>
          <Space direction="vertical" size={"middle"} style={{width: "100%"}}>
            <Form.Item
              label={
                <Typography.Text ellipsis>Chọn nội dung phụ thu</Typography.Text>
              }
              name="tenVatTu"
              labelAlign="left"
              labelCol={{ span: 4 }}
              wrapperCol={{ span: 24 }}>
              {/* <Row gutter={[16, 8]} justify={"space-between"}>
                <InputFields data={field}></InputFields> */}
                <Select
                  allowClear
                  placeholder="Chọn"
                  options={option}
                  onChange={handleOnChange}
                ></Select>
              {/* </Row> */}
            </Form.Item>
            <Row gutter={[16, 8]} justify={"end"}>
              <Space>
                <Button
                  key="cancel"
                  type="primary"
                  danger
                  onClick={handleCancel}
                >
                  Huỷ bỏ
                </Button>
                {/* <Button
                  key="submit"
                  type="primary"
                  htmlType="submit"
                  icon={<Icons.save rev={0} />}
                  // onClick={handleCancel}
                >
                  Lưu lại
                </Button> */}
                <Button
                  type="primary"
                  onClick={handleOnSubmit}
                >
                  Đồng ý
                </Button>
              </Space>
            </Row>
          </Space>
        </Form>
      </div>
      <ModalPrintPPT
        isShowModal={isShowModalPrintPPT}
        handleOk={handleOpenPPT}
        handleCancel={handleCancelPrintPPT}
        listId={listId}
        dataPPT={dataPPTOption}
        value={label}
      />
    </Modal>
  )
}

export default ModalOptionPrint